import { IToolSuggestion } from './tool-suggestion'

export enum CompanySize {
  Small = 'small',
  Growing = 'growing',
  Established = 'established',
}

export enum SeniorityLevel {
  Junior = 'junior',
  MidLevel = 'mid_level',
  Senior = 'senior',
  StaffLead = 'staff_lead',
  HeadVp = 'head_vp',
}

/**
 * Lean profile shape used by the onboarding wizard. The backend `/profiles`
 * resource holds many more fields, but auth-web only reads/writes the subset
 * collected during onboarding.
 */
export interface IProfile {
  _id?: string
  companyName?: string
  companySize?: CompanySize | null
  companyDescription?: string | null
  workArea?: string | null
  seniorityLevel?: SeniorityLevel | null
  companyIndustry?: string | null
  workAreaCoreTasks?: string[] | null
  workAreaCoreTasksNotes?: string | null
  tools?: IToolSuggestion[] | null
  exploreNewTools?: boolean | null
}
